<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalOverview",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "Currency Code",
					component: "select",
					bindTo: "case.facts.currencyCode",
					props: {
						options: [
							{
								name: "Hong Kong Dollar",
								value: "HKD"
							}
						]
					}
				},
				{
					label: "Sign Date",
					component: "date",
					dataType: "date",
					bindTo: "case.facts.signDate"
				}
			]
		}
	}
}
</script>
